import React, { memo, type ReactNode } from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';

type Props = {
	children: ReactNode;
	message: string;
	testId?: string;
};

const styles = cssMap({
	container: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	hotspotWrapper: {
		flex: '1 1 auto',
	},
	hotspot: {
		display: 'block',
		height: '20px',
	},
});

export const RestrictedTooltipHotspot = memo(({ children, message, testId }: Props) => (
	<Box xcss={styles.container} testId={testId}>
		{children}
		<Box xcss={styles.hotspotWrapper}>
			<Tooltip content={message}>
				<Box as="span" xcss={styles.hotspot} />
			</Tooltip>
		</Box>
	</Box>
));

RestrictedTooltipHotspot.displayName = 'RestrictedTooltipHotspot';
